import { trackCioEvent } from '../cio';
import { identifyUser } from '../identifyUser';
import { AnalyticsEvent } from '../types';

export type ContactInfoCollectedEventProperties = {
  primaryContactEmail: string;
  primaryContactPhoneNumber: string;
  primaryContactPhoneNumberVerified: boolean;
  patientRecipient: 'me' | 'someone-else';
};

export function trackContactInfoCollected(properties: ContactInfoCollectedEventProperties) {
  if (properties.primaryContactEmail) {
    void identifyUser(properties.primaryContactEmail);
  }

  trackCioEvent(AnalyticsEvent.DTC_CONTACT_INFO_SUBMITTED, properties);
}
